module.exports = __webpack_public_path__ + "img/share_close_icon.8898e657.png";